import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { getFilterAttributes, exportPdf } from '../../app.utils';
import { UsecaseBaseComponent } from '../usecase-base/usecase-base.component';
import { ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-usecase-pivot',
  templateUrl: './usecase-pivot.component.html',
  styleUrls: ['./usecase-pivot.component.scss'],
})
export class UsecasePivotComponent extends UsecaseBaseComponent {
  @ViewChild('content1')
  content!: ElementRef;
  public loading: boolean = false;
  public attributeId: number = 0;
  public filterAttributes: any = [];
  public pivotform: any = {
    chart_type: 'html',
  };

  public reqform: any = {
    chart_type: 'html',
  };

  pivotUrl: SafeResourceUrl | null = null;
  pivottable: any = '<div><div>';

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {
    super(locator, route);
    let _self = this;
    _self.is_paging = false;
    if (route.snapshot.paramMap.get('appId'))
      _self.appId = Number(route.snapshot.paramMap.get('appId'));

    if (route.snapshot.paramMap.get('usecaseId'))
      _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));

    _self.locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  removeFormField(field: string, value: any, isKey: boolean = false) {
    if (isKey) {
      delete this.reqform[field]?.[value];
    } else if (Array.isArray(this.reqform[field])) {
      const index = this.reqform[field].indexOf(value);
      if (index > -1) this.reqform[field].splice(index, 1);
    }
  }

  updateFormField(
    field: string,
    value: any,
    aggValue?: any,
    isKey: boolean = false
  ) {
    this.reqform[field] = this.reqform[field] || (isKey ? {} : []);
    if (isKey) {
      aggValue = aggValue?.trim() || 'sum';
      this.reqform[field][value] = aggValue;
    } else {
      this.reqform[field].push(value);
    }
    console.log(this.reqform);
  }

  override ngOnInit() {
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        if (_self.usecaseId) {
          _self.getUsecaseSchema(false);
        }
      });
  }

  override afterUsecaseAttrGet() {
    this.filterAttributes = getFilterAttributes(this.usecaseAttributes);
  }

  resetSearchValues() {
    this.reqform = {};
  }

  searchAndDraw(flag: boolean = true) {
    let _self = this;
    if (flag) {
      this.getUsecaseDataList(() => {
        _self.cleanData();
        _self.drawPivot();
      });
    } else {
      _self.drawPivot();
    }
  }

  drawPivot() {
    let _self = this;
    _self.loading = true;
    _self.form['error'] = false;
    _self.form['message'] = '';
    _self.pivottable = '';
    _self.pivotUrl = null;
    _self.reqform['title'] = _self.usecase['name'];
    _self.reqform['values'] = this.reqform['aggfunc']
      ? Object.keys(this.reqform['aggfunc'])
      : [];
    _self.reqform['numericfields'] = _self.findNumericFields();
    if (
      _self.reqform &&
      (_self.reqform['index'] != null || _self.reqform['columns'] != null)
    ) {
      if (_self.reqform['chart_type'] === 'html') {
        _self.locator.config
          .getProperty('endpoint.pivot_server')
          .then((property: string) => {
            let url = property + '/pivot_table_image';
            _self.reqform['data'] = _self.sanitizedData;
            let client = _self.locator.http.getClient();
            client.post(url, _self.reqform, { responseType: 'text' }).subscribe(
              (data: any) => {
                try {
                  const jsonResponse = JSON.parse(data);
                  if (!jsonResponse['success']) {
                    _self.form['error'] = true;
                    _self.form['message'] = jsonResponse['message'];
                    _self.loading = false;
                    return;
                  }
                } catch (error) {
                  console.error('Error parsing JSON from Blob:', error);
                }
                _self.pivottable = data;
                _self.loading = false;
              },
              (data: any) => {
                console.error(data);
                _self.loading = false;
              }
            );
          });
      } else {
        _self.locator.config
          .getProperty('endpoint.pivot_server')
          .then((property: string) => {
            let url = property + '/pivot_table_image';
            _self.reqform['data'] = _self.sanitizedData;
            let client = _self.locator.http.getClient();
            client.post(url, _self.reqform, { responseType: 'blob' }).subscribe(
              (data: any) => {
                const contentType = data.type;
                if (contentType.includes('application/json')) {
                  const reader = new FileReader();
                  reader.onload = () => {
                    const text = reader.result as string; // This will be the text from the Blob
                    try {
                      const jsonResponse = JSON.parse(text);
                      if (!jsonResponse['success']) {
                        _self.form['error'] = true;
                        _self.form['message'] = jsonResponse['message'];
                      }
                    } catch (error) {
                      console.error('Error parsing JSON from Blob:', error);
                    }
                  };

                  reader.readAsText(data);
                } else {
                  const objectUrl = URL.createObjectURL(data);
                  _self.pivotUrl =
                    this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
                }
                _self.loading = false;
              },
              (data: any) => {
                _self.loading = false;
              }
            );
          });
      }
    } else {
      _self.form['error'] = false;
      _self.form['message'] = 'Please select rows or columns before process';
      _self.loading = false;
    }
  }

  public sanitizedData: any = [];

  public cleanData(): any {
    let _self = this;
    const allowedKeysMap = _self.filterAttributes.reduce(
      (map: any, attr: any) => {
        if (attr['code'] && attr['label']) {
          map[attr['code']] = attr['label']; // Map code to label
        }
        return map;
      },
      {}
    );

    _self.sanitizedData = _self.usecaseData.map((item: any) => {
      // Construct a new object with keys replaced by their labels
      const sanitizedItem: any = {};
      Object.keys(allowedKeysMap).forEach((key: string) => {
        if (key in item) {
          sanitizedItem[allowedKeysMap[key]] = item[key]; // Use label as the key
        }
      });
      return sanitizedItem; // Return the newly constructed object
    });
  }

  // Function to find all numeric fields
  findNumericFields = () => {
    const numericFields = new Set();
    this.sanitizedData.forEach((item: any) => {
      Object.keys(item).forEach((key) => {
        if (typeof item[key] === 'number') {
          numericFields.add(key);
        }
      });
    });
    return Array.from(numericFields);
  };
}
